import styled from "@emotion/styled";

export const Content = styled.div`
		display: flex;
		flex-grow: 1;
		height: calc(100% - 50px)
	`;
